<template>
  <div class="woocommerce-notices-wrapper">
    <div class="woocommerce-message" id="notice" role="alert">
      <i @click="unset" class="fa fa-times"></i>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  methods: {
    unset() {
      this.$store.commit('unsetNotice')
    },
  },
}
</script>

<style>
.woocommerce-notices-wrapper .woocommerce-message .fa {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
}
@media only screen and (max-width: 768px) {
  #notice {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
